function openSearch() {
  if (!app.searchModal) {
    app.searchModal = new jBox('Modal', {
      addClass: 'search-modal__wrapper',
      content: '<div class="search-modal__container"></div>',
      onCreated: function () {
        updateModalCloseButton(this);

        var container = this.wrapper.find('.search-modal__container');

        var searchForm = $('<form class="search-modal__form" action="/suche" method="get"/>');
        container.append(searchForm);

        var searchTextfield = $(
          '<input class="search-modal__input" type="text" name="s" value="" placeholder="Suchbegriff..."/>'
        );
        searchForm.append(searchTextfield);

        var searchButton = $(
          '<button type="submit" class="search-modal__button"/>'
        ).html(
          '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path></svg>'
        );
        searchForm.append(searchButton);
      },
      onOpen: function () {
        requestAnimationFrame(function () {
          $('.search-modal__input').focus();
        });
      }
    });
  }
  closeMenu();
  app.searchModal.open();
}
